import { makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexGrow: 1,
		},
		containerGroup: {
			display: 'flex',
			flexDirection: 'column',
		},
		containerFormGroup: {
			width: '100%',
			display: 'flex',
			flexDirection: 'row',
			marginBottom: 20,
		},
		containerButtonAdd: {
			width: '100%',
			display: 'flex',
			alignItems: 'flex-end',
			flexDirection: 'column',
			marginBottom: 20,
		},
		btnSave: {
			height: 50,
			marginLeft: '15px !important',
		},
		btnAdd: {
			height: 50,
			width: 150,
		},
		addImage: {
			height: 50,
			width: 180,
			backgroundColor: `${theme.palette.secondary.dark} !important`,
			color: '#FFFFFF !important',
			marginLeft: '15px !important',
		},
		btnSaveGroup: {
			width: '10% !important',
			height: 50,
			marginLeft: '15px !important',
		},
		addImageGroup: {
			height: 50,
			width: '20% !important',
			backgroundColor: `${theme.palette.secondary.dark} !important`,
			color: '#FFFFFF !important',
			marginLeft: '15px !important',
		},
		textFieldGroup: {
			height: 50,
			marginRight: '5px !important',
			width: '35% !important',
		},
		textField: {
			height: 50,
		},
		btnCleanStates: {
			marginLeft: '10px !important',
		},
		headerTable: {
			backgroundColor: theme.palette.secondary.dark,
		},
		headerTextTable: {
			color: '#FFFFFF !important',
		},
		headerTextTableActions: {
			width: '10%',
			color: '#FFFFFF !important',
		},
		padding5: {
			padding: 5,
		},
	}),
);
